import {IDIOMAS, NOMBRE_IDIOMA, type Idioma} from '@cnc/contracts';
import {useGuardarPreferencias} from '../api/sesion';
import {useIdioma} from '../i18n/contexto-idioma';
import {tr} from '../i18n/idioma';

// Botones ES | EN | HI (hindi desde el 9/10/2026). Con sesion abierta el idioma queda guardado en el perfil
// de la persona (la sigue a cualquier computador); en la pantalla de ingreso
// solo cambia esa pantalla.
export function SelectorDeIdioma({guardarEnPerfil = false}: {guardarEnPerfil?: boolean}) {
  const {idioma, cambiar} = useIdioma();
  const guardar = useGuardarPreferencias();
  // Primero se guarda en el perfil (si no, al recargar la sesion volveria el idioma anterior).
  const elegir = async (nuevo: Idioma) => {
    if (nuevo === idioma) return;
    if (guardarEnPerfil) await guardar.mutateAsync({columnas: {}, idioma: nuevo}).catch(() => undefined);
    cambiar(nuevo);
  };
  return (
    <div
      role="group"
      aria-label={tr('Idioma', 'Language')}
      className="inline-flex rounded-md border border-linea text-xs"
    >
      {IDIOMAS.map(opcion => (
        <button
          key={opcion}
          type="button"
          onClick={() => void elegir(opcion)}
          disabled={guardar.isPending}
          aria-pressed={opcion === idioma}
          title={NOMBRE_IDIOMA[opcion]}
          className={`px-2 py-0.5 first:rounded-l-md last:rounded-r-md ${
            opcion === idioma ? 'bg-verde-claro font-semibold text-verde-oscuro' : 'text-apagado hover:bg-papel'
          }`}
        >
          {opcion.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
